import * as React from "react";
import "./footer-view-cart.less";
import { ModalComponent } from "shared/components/modal/modal";
import { useAppDispatch, useAppSelector } from "app.hook";
import { shallowEqual } from "react-redux";
import {
  hideViewCartModal,
  selectShoppingCart,
  selectViewCartModal,
} from "states/shopping-cart/shopping-cart.slice";
import { ItemModalViewMobileCart } from "./components/item-view-cart-mobile";
import { nanoid } from "@reduxjs/toolkit";
import { formatMoney } from "shared/plugins/string-helper";
import { Link, useHistory, useLocation } from "react-router-dom";
import { CHECKOUT_ROUTE, VIEW_MENU_ROUTE } from "shared/constants/routes";
import { showOrderGuestModal } from "states/global-value/global-value.slice";
import { selectSignIn } from "states/global-value/global-value.slice";
import { IconShoppingBag } from "themes";
import { isMobile, isTablet } from "react-device-detect";
import { ItemModalViewCart } from "./components/item-view-cart";
export function DisplayFooterViewCart() {
  const currentShoppingCart = useAppSelector(selectShoppingCart, shallowEqual);
  const currentViewCartModal = useAppSelector(
    selectViewCartModal,
    shallowEqual
  );
  const isLogged = useAppSelector(selectSignIn, shallowEqual);
  const dispatch = useAppDispatch();
  const history = useHistory();
  const location = useLocation();
  const totalItems = currentShoppingCart?.items?.reduce((sum, item) => sum + item.quantity, 0) || 0;
  const handleCheckout = () => {
    if (location.pathname !== CHECKOUT_ROUTE) {
      if (!isLogged) {
        dispatch(showOrderGuestModal());
      } else {
        history.push(CHECKOUT_ROUTE);
      }
    }

    dispatch(hideViewCartModal());
  };

  return (
    <>
      {isMobile || isTablet ? (
        <ModalComponent
          isCustomizeFooter={true}
          height={`100%`}
          isModal={true}
          className="view-cart-modal"
          title={
            <div className="cart-title-header">
              <IconShoppingBag width={24} />
              <span>View Cart</span>
              {totalItems > 0 && <span className="item-count-badge">{totalItems}</span>}
            </div>
          }
          isOpenModal={currentViewCartModal}
          customizeFooterFixed={
            <div className="cart-summary-footer">
              <div className="cart-summary">
                <div className="summary-row">
                  <span className="summary-label">Subtotal</span>
                  <span className="summary-value">{formatMoney(currentShoppingCart.subTotal, 2, ".", ",", "$")}</span>
                </div>
              </div>
              <button className="checkout-btn" onClick={handleCheckout}>
                <span className="checkout-icon">💳</span>
                Proceed to Checkout
              </button>
            </div>
          }
          onCloseModal={() => {
            dispatch(hideViewCartModal());
          }}
        >
          {currentShoppingCart?.items?.length > 0 ? (
            <>
              <div className="cart-items-container">
                {currentShoppingCart?.items?.map((m, index) => (
                  <ItemModalViewMobileCart key={nanoid()} index={index} item={m} />
                ))}
              </div>

            </>
          ) : (
            <div className="empty-cart-state">
              <div className="empty-cart-icon">🛒</div>
              <div className="empty-cart-text">Your cart is empty</div>
              <button className="browse-menu-btn" onClick={() => dispatch(hideViewCartModal())}>
                Browse Menu
              </button>
            </div>
          )}
        </ModalComponent>
      ) : (
        <ModalComponent
          portalClassName={`ViewCartDesktop cart-modal-desktop`}
          width={1200}
          isCustomizeFooter={true}
          isModal={true}
          className=""
          title={
            <div className="desktop-cart-header">
              <h1 className="desktop-cart-title">
                <IconShoppingBag width={32} />
                <span>Your Cart</span>
              </h1>
            </div>
          }
          isOpenModal={currentViewCartModal}
          onCloseModal={() => { dispatch(hideViewCartModal()) }}
        >
          {currentShoppingCart?.items?.length > 0 ? (
            <>
              <div className="desktop-cart-items">
                {currentShoppingCart?.items?.map((item, index) => (
                  <ItemModalViewCart index={index} key={nanoid()} item={item} />
                ))}
              </div>

              <div className="desktop-cart-summary">
                <div className="summary-row">
                  <span className="summary-label">Subtotal ({totalItems} items)</span>
                  <span className="summary-value">{formatMoney(currentShoppingCart.subTotal, 2, ".", ",", "$")}</span>
                </div>
              </div>

              <div className="desktop-cart-actions">
                <button
                  onClick={() => {
                    if (location.pathname !== VIEW_MENU_ROUTE) {
                      history.push(VIEW_MENU_ROUTE)
                    }
                    dispatch(hideViewCartModal());
                  }}
                  className="btn btn-secondary"
                >
                  <span className="btn-icon">🛍️</span>
                  Add More Items
                </button>
                {location.pathname === CHECKOUT_ROUTE ? (
                  <button
                    onClick={() => {
                      dispatch(hideViewCartModal());
                    }}
                    className="btn btn-primary"
                  >
                    <span className="btn-icon">💳</span>
                    Proceed to Payment
                  </button>
                ) : (
                  <button
                    onClick={() => {
                      if (!isLogged) {
                        dispatch(showOrderGuestModal());
                      } else {
                        history.push(CHECKOUT_ROUTE);
                      }
                      dispatch(hideViewCartModal());
                    }}
                    className="btn btn-primary"
                    aria-label="proceed to payment"
                  >
                    <span className="btn-icon">💳</span>
                    Proceed to Payment
                  </button>
                )}
              </div>
            </>
          ) : (
            <div className="empty-cart-desktop">
              <div className="empty-cart-icon">🛒</div>
              <div className="empty-cart-text">Your cart is empty</div>
              <button className="btn btn-primary" onClick={() => {
                dispatch(hideViewCartModal());
                history.push(VIEW_MENU_ROUTE);
              }}>
                <span className="btn-icon">🛍️</span>
                Start Shopping
              </button>
            </div>
          )}
        </ModalComponent>
      )}

    </>
  );
}
